import { ILogger } from "@tdp/common/telemetry";

// eslint-disable-next-line no-restricted-imports
import { IAuthenticatedImageFetcher, IAuthenticatedImageReadResult } from "../abstractions";

export interface AuthenticatedImageFetcherDeps {
  apiFetch: typeof fetch;
  logger: ILogger;
}
export class AuthenticatedImageFetcher implements IAuthenticatedImageFetcher {
  private apiFetch: typeof fetch;
  private logger: ILogger;

  constructor(deps: AuthenticatedImageFetcherDeps) {
    this.apiFetch = deps.apiFetch;
    this.logger = deps.logger;
  }

  async readImage(path: string): Promise<IAuthenticatedImageReadResult> {
    const result = await this.apiFetch(path); //TODO(nibeauli): check if we need to set content type? 
    if (result.status != 200) {
      return {
        type: 'failure',
        error: result.statusText
      }
    }

    const data = await result.blob();
    return {
      type: 'success',
      data
    }
  }

}
